module.exports = __webpack_public_path__ + "img/syukyaku-top-021.295975da.jpg";